export default {
    matchConstructor: (phoneFormat) => ({
        message: phoneFormat
            ? `В начале телефона разрешены только цифры(а) ${phoneFormat.allowedFirstDigits.join(", ")}`
            : "Неверный формат телефона",
        excludeEmptyString: true,
    }),
    regExpConstructor: (phoneFormat) => new RegExp(phoneFormat ? `^[${phoneFormat.allowedFirstDigits.join("")}]` : ".+", "gm"),
};
//# sourceMappingURL=phone.js.map